<template>
  <div id="header" class="header">
    <div class="header-box">
      <router-link to="/"><img class="logo" src="../assets/images/logo.png"></router-link>

      <div :class="navAct?'nav-box':'nav-box active'" :style="navH">
        <ul>
          <li v-for="(iten,index) in nav" @click="mainChoose(iten.name)" :class="navLight==iten.name?'head-li active':'head-li'"><router-link v-if="iten" :to="iten.url">{{iten.title}}</router-link></li>
          <li>
            <!-- <div class="language-boxs">
              <span :class="language=='Japanese'?'head-li active':'head-li'" @click="languageChoose('Japanese')">日本語</span>
              <span>|</span><span :class="language=='english'?'active':''" @click="languageChoose('english')">EN</span>
            </div> -->
          </li>
        </ul>
      </div>
      <div class="navbar-toggle" @click="navToggle()">
      	<span class="sr-only"></span>
      	<span class="icon-bar"></span>
      	<span class="icon-bar"></span>
      	<span class="icon-bar"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        navdata:'',
        navAct:true,
        navH:{
          height:'auto'
        },
        heiAct:0,
        language:'english'
      }
    },
    computed: {
      nav() {
        return this.$store.state.languagesData.nav;
      },
      navLight(){
        return this.$store.state.lighted;
      }
    },
    props: {
        resData: {}
    },
    watch: {
        resData(newData){
          this.navdata=newData;
        }
    },
    methods:{
      mainChoose(type){
        this.heiAct=type;
        this.navToggle();
        this.$store.commit("highLighted",type);
      },
      languageChoose(val){
        this.language=val;
        this.$parent.languagefun(val);
        this.navToggle();
        this.$store.commit("changeLanguage",val);
      },
      navToggle(){
        if (document.body.clientWidth<1000) {
          this.navAct=!this.navAct;
          let h=document.getElementsByTagName('li')[0].offsetHeight*document.getElementsByClassName('head-li').length;
          if (this.navAct) {
            this.navH={
              height:0
            }
          } else{
            this.navH={
              height:h+'px'
            }
          }
        }
      }
    },
    mounted() {
      let this_=this;
      this.$store.commit("highLighted",this.$route.name);
      this.$parent.getlan();
      this.language=this.$parent.languages;
      if (document.body.clientWidth<1000) {
        this.navH={
          height:0
        }
      }
      window.addEventListener("resize",function(){
          if (document.body.clientWidth<1000) {
            this_.navH={
              height:0
            }
          }else{
            this_.navH={
              height:'auto'
            }
          }
      })
    }
  }
</script>

<style scoped>
  .header{
    background-color: rgba(0,0,0,.1);
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 11;
  }
  .header-box{
    height: 90px;
    max-width: 1200px;
    margin: auto;
    position: relative;
  }
  .logo{
    height: 70px;
    margin: 10px 0;
  }
  .nav-box{
    float: right;
    font-size: 0;
  }
  .nav-box li{
    display: inline-block;
    line-height: 90px;
    font-size: 18px;
    cursor: pointer;
    font-weight: 700;
    color: white;
    vertical-align: middle;
  }
  .nav-box li a{
    padding: 0 20px;
    color: #C2C2C2;
    display: block;
  }
  .nav-box li.active a{
    color: #7CC4E3;
  }
  .language-boxs{
    font-size: 0;
  }
  .nav-box li span{
    display: inline-block;
    margin: 0 5px;
    font-size: 18px;
    vertical-align: middle;
  }
  .nav-box li span.active{
    color: #7CC4E3;
  }
  .navbar-toggle {
      position: absolute;
      right: 3%;
      padding: 9px 10px;
      margin-top: 18px;
      margin-right: 10px;
      background-color: white;
      background-image: none;
      border: 1px solid #ddd;
      border-radius: 4px;
      display: none;
      cursor: pointer;
  }
  .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      border: 0;
  }
  .navbar-toggle .icon-bar {
      display: block;
      width: 22px;
      height: 2px;
      border-radius: 1px;
      background-color: #888;
  }
  .navbar-toggle .icon-bar + .icon-bar {
      margin-top: 4px;
  }

  @media screen and (max-width: 1000px){
    .header-box{
      height: 70px;
      max-width: 750px;
    }
    .logo{
      height: 50px;
      margin: 10px 10px;
      float: left;
    }

    .nav-box{
      float: left;
      width: 100%;
      position: absolute;
      z-index: 20;
      background-color: rgba(0,0,0,0.7);
      top: 70px;
      transition: all .2s ease-in;
      height: 0;
      overflow: hidden;
    }
    .nav-box ul{
      padding: 0 5%;
    }
    .nav-box li{
      line-height: initial;
      display: block;
      width: 100%;
      text-align: left;
      box-sizing: border-box;
      font-size: 16px;
      border-top: 1px solid #ddd;
    }
    .nav-box li a{
      padding: 3% 0;
    }
    .nav-box li:nth-last-of-type(1){
      text-align: center;
      padding: 3% 0;
    }
    .nav-box li span{
      margin:0 10%;
    }
    .navbar-toggle{
    	display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue